import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MessageService } from 'src/app/shell/message.service';
import { read, utils, WorkBook, WorkSheet } from "xlsx";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, OnInit } from '@angular/core';
import { ExportExcelServiceService } from 'src/app/shared/exportar-excel/export-excel-service.service';
import { UsuarioDTO } from 'src/app/shared/models/notificaciones/UsuarioDTO';
import { UsuarioService } from "../../account/usuario.service";
import { ModalConfirmComponent } from "../../shared/generic-modals/modal-confirm.component";
import { AerovalesService } from "../aerovales.service";
import { ErrorModel } from "../../shared/models/ErrorModel";
import { environment } from "src/environments/environment";

export interface DatoExcel {
  NumeroDocumentoOperador: string;
  FechaHoraDespacho: string;
  NumeroDocumentoCliente: string;
  CodigoProducto: string;
  Cantidad: number;
  Supervisor: UsuarioDTO;
}

@Component({
  selector: 'app-modal-cargar-excel',
  templateUrl: './modal-cargar-excel.component.html',
})

export class ModalCargarExcelComponent implements OnInit{
  guardando:boolean = false;
  userFileName: string;
  mensajeError: string;
  fileUpload = { status: '', message: '', filePath: '', length: 0 };
  subiendoPrecios: boolean = false;
  form: FormGroup;
  encabezadosExcel: string[] = [];
  listaNombreColumnasValidas : string[] = [
    '*Operador',
    '*FechaHoraDespacho',
    '*Cliente',
    '*Aeroespecialidades',
    '*Cantidad'
  ];
  jsonResponse: any[] = [];
  errorConexionBackend: string;
  errorDatosExcel: string;
  sinErrores: string = null;
  noPuedeCargar: boolean = true;
  datosExcel: DatoExcel[] = [];
  procesando: boolean = false;
  pendienteCargar: boolean = true;
  totalAerovales: number = 0;

  readonly CANTIDAD_REGISTROS_POR_ENVIO = 100; 
  bloquesTotales: number = 0;
  bloquesCargados: number = 0;
  porcentajeCarga: number = 0;
  mensajeProcesamiento: string = null;

  constructor(public modal: NgbActiveModal,
              private excelService: ExportExcelServiceService,
              private fb: FormBuilder,
              private modalService: NgbModal,
              private usuarioService: UsuarioService,
              private aerovaleService: AerovalesService,
              private messageService: MessageService) { }

  ngOnInit(){
    this.form = this.fb.group({
      name: [''],
      profile: [''],
      inputFile: ['', Validators.required],
    });
  }

  descargarPlantilla() {
    window.open('/assets/excel-carga-masiva/PlantillaDeEjemplo.xlsx', '_blank');
  }

  resetearArchivo(){
    this.userFileName = '';
    this.errorDatosExcel = null;
    this.sinErrores = null;
    this.errorConexionBackend = null;
    this.datosExcel = [];
    this.noPuedeCargar = true;
    this.procesando = false;
    this.encabezadosExcel = [];

    this.porcentajeCarga = 0;
    this.bloquesCargados = 0;
    this.bloquesTotales = 0;
    this.mensajeProcesamiento = null;

    this.form.patchValue({
      inputFile: ''
    })
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0]
      this.form.get('profile').setValue(file);
      this.userFileName = file.name;
      this.datosExcel = [];
      this.procesando = true;
      setTimeout(() => {
        this.procesarExcel();
      }, 3000);

    }
  }

  reset(limpiarMensajes: boolean = false, limpiarInput: boolean = false) {
    this.subiendoPrecios = false;
    if (limpiarInput) {
      this.userFileName = '';
    }
    if (limpiarMensajes)
      this.fileUpload = { status: '', message: '', filePath: '', length: 0 };
  }

  validarColumnas(row: any[]){
    const cantColumnasValidad = this.getCantidadColumnasValidas();
    if(cantColumnasValidad != this.listaNombreColumnasValidas.length){
      this.errorDatosExcel = `Error en encabezado de columna del excel. <br/>Se esperaban ${this.listaNombreColumnasValidas.length} columnas pero el excel tiene ${cantColumnasValidad} columnas`;      return false;
    }
    for(let i = 0; i < cantColumnasValidad; i++){
      if(row[i] != this.listaNombreColumnasValidas[i]){
        this.errorDatosExcel = "Error en encabezado de columna del excel. Se esperaba '" + this.listaNombreColumnasValidas[i] + "' pero se encontro '" + row[i] +"' en la columna " + i ;
        return false;
      }
    }
    return true;
  }

  getCantidadColumnasValidas(){
    return this.encabezadosExcel.length;
  }

  procesarExcel() {
    this.errorDatosExcel = null; // Limpiar errores previos
    this.sinErrores = null;

    const archivo = this.form.get('profile').value;
    if (archivo) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        try {
          /* read workbook */
          const bstr: string = e.target.result;
          const wb: WorkBook = read(bstr, { type: 'binary' });

          /* grab first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: WorkSheet = wb.Sheets[wsname];

          /* save data */
          const rows: any[][] = utils.sheet_to_json(ws, { header: 1 });

          this.encabezadosExcel = rows[0] || [];

          const cantidadFilasValidas = this.calcularCantidadFilasValidas(rows);

          if (cantidadFilasValidas == 0) {
            this.errorDatosExcel = "El archivo no posee datos para cargar.";
            this.reset();
          } else {
            if (!this.validarColumnas(rows[0])) {
              this.procesando = false;
              return;
            }

            if (rows == null) {
              this.procesando = false;
              return;
            }
            // Procesar filas (excluyendo encabezado) y almacenar en datosExcel
            this.datosExcel = this.procesarFilasExcel(rows.slice(1));

            if (this.datosExcel) {
              this.sinErrores = "El archivo esta listo para ser cargado";
              this.noPuedeCargar = false;
            } else {
              this.sinErrores = null;
            }
          }
        } catch (error) {
          this.errorDatosExcel = "Ocurrió un error al procesar el archivo. Por favor, inténtelo de nuevo.";
          console.error(error);
        } finally {
          this.procesando = false; // Finalizar estado de procesamiento
        }
      };

      reader.onerror = () => {
        this.errorDatosExcel = "Error al leer el archivo.";
        this.procesando = false;
      };

      reader.readAsBinaryString(archivo);
    } else {
      this.errorDatosExcel = "No se pudo leer el archivo excel cargado.";
      this.procesando = false;
    }
  }

  procesarFilasExcel(filas: any[][]): DatoExcel[] {
    const datos: DatoExcel[] = [];
    let hayErrores = false;
    this.errorDatosExcel = "";

    if (environment.name === 'dev_electrica') {
      console.log('filas: ', filas);
    }

    filas.filter(fila => fila.length > 0).forEach((col, index) => {
      // Crear objeto con la nueva estructura (sin FechaHoraDespacho, se establece al guardar)
      const dato: DatoExcel = {
        NumeroDocumentoOperador: col[0] ? col[0].toString().trim() : '',
        FechaHoraDespacho: '', // Se establece al guardar
        NumeroDocumentoCliente: col[2] ? col[2].toString().trim() : '',
        CodigoProducto: col[3] ? col[3].toString().trim() : '',
        Cantidad: this.convertirANumero(col[4]),
        Supervisor: new UsuarioDTO() //Se establece al guardar
      };

      if (environment.name === 'dev_electrica') {
        console.log(dato);        
      }

      // Validaciones (sin validar FechaHoraDespacho ya que se establece al guardar)
      const numeroFila = index + 1;
      if (!dato.NumeroDocumentoOperador) {
        this.errorDatosExcel += `Fila ${numeroFila + 1}: Operador es obligatorio.<br>`;
        hayErrores = true;
      }
      if (!dato.NumeroDocumentoCliente) {
        this.errorDatosExcel += `Fila ${numeroFila + 1}: Cliente es obligatorio.<br>`;
        hayErrores = true;
      }
      if (!dato.CodigoProducto) {
        this.errorDatosExcel += `Fila ${numeroFila + 1}: Código de Producto es obligatorio.<br>`;
        hayErrores = true;
      }
      if (isNaN(dato.Cantidad)) {
        this.errorDatosExcel += `Fila ${numeroFila + 1}: Cantidad debe ser un número válido.<br>`;
        hayErrores = true;
      }

      datos.push(dato);
    });

    return hayErrores ? null : datos;
  }

  obtenerFechaActual(): string {
    const fecha = new Date();
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    const segundos = fecha.getSeconds().toString().padStart(2, '0');

    return `${anio}-${mes}-${dia}T${horas}:${minutos}:${segundos}z`;
  }


// Función auxiliar para convertir a número
  convertirANumero(valor: any): number {
    if (valor === null || valor === undefined) return NaN;
    if (typeof valor === 'number') return valor;

    // Intentar convertir string a número
    const num = Number(valor.toString().replace(',', '.'));
    return isNaN(num) ? NaN : num;
  }

  calcularCantidadFilasValidas(rows: any[][]){
    // Busca la primera fila con todas las columnas vacias.
    let indexCol, indexRow = 0;
    //Si hay que validar mas filas se cambia el 1 por rows.length
    for (indexRow = 0; indexRow < 1; indexRow++) {
      for(indexCol = 0; indexCol < this.getCantidadColumnasValidas(); indexCol++){
        if(rows[indexRow][indexCol] != null){
          break;
        }
      }
      if(indexCol == this.getCantidadColumnasValidas()){
        return indexRow;
      }
    }
    return indexRow;
  }

  importarAerovalesAeroespecialidad() {
    if (!this.datosExcel || this.datosExcel.length === 0) {
      this.messageService.showErrorMessage('No hay datos válidos para cargar.');
      return;
    }

    this.totalAerovales = this.datosExcel.length;

    const fechaActual = this.obtenerFechaActual();
    const supervisor = this.armarUsuario();
    this.datosExcel = this.datosExcel.map(dato => ({
      ...dato,
      FechaHoraDespacho: fechaActual,
      Supervisor: supervisor
    }));

    this.jsonResponse = [];
    this.errorConexionBackend = null;
    this.guardando = true;
    this.bloquesTotales = this.obtenerTotalBloques(this.totalAerovales);
    this.bloquesCargados = 0;
    this.porcentajeCarga = 0;
    this.mensajeProcesamiento = `Se inicia el procesamiento de ${this.totalAerovales} aerovales.`;

    this.procesarBloque(1);
  }

  private procesarBloque(bloque: number) {
    const inicio = (bloque - 1) * this.CANTIDAD_REGISTROS_POR_ENVIO;
    const fin = Math.min(inicio + this.CANTIDAD_REGISTROS_POR_ENVIO, this.datosExcel.length);
    const lote = this.datosExcel.slice(inicio, fin);

    this.mensajeProcesamiento = `Procesando bloque ${bloque} de ${this.bloquesTotales} (${fin} / ${this.totalAerovales})...`;

    this.aerovaleService.importarAerovalesAeroespecialidadElectrica(lote)
      .subscribe(
        (result: any[]) => {
          this.jsonResponse = [...this.jsonResponse, ...(result || [])];

          this.bloquesCargados = bloque;
          this.porcentajeCarga = Math.round((this.bloquesCargados / this.bloquesTotales) * 100);

          if (bloque < this.bloquesTotales) {
            this.procesarBloque(bloque + 1);
          } else {
            this.guardando = false;
            this.mensajeProcesamiento = null;
            this.pendienteCargar = false; 
          }
        },
        (error: ErrorModel) => {
          this.guardando = false;
          this.errorConexionBackend = `Error al cargar el bloque ${bloque} de ${this.bloquesTotales}: ${error.description}`;
        }
      );
  }

  private obtenerTotalBloques(total: number): number {
    return Math.ceil(total / this.CANTIDAD_REGISTROS_POR_ENVIO);
  }

  armarUsuario() : UsuarioDTO {
    const usuario = {
      id: this.usuarioService.getIdUsuario(),
      nombresCompletos: this.usuarioService.getNombresCompletosUsuario(),
      dni: this.usuarioService.getDniUsuario(),
      email: this.usuarioService.getEmailUsuario()
    }
    return usuario;
  }

  closeModal() {
    if (!this.pendienteCargar) {
      this.modal.close(true);
      return;
    }
    if (!this.noPuedeCargar){
      const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true });
      modalRef.componentInstance.titulo = "Atención";
      modalRef.componentInstance.mensaje = "¿Confirma salir sin cargar el archivo?";
      modalRef.componentInstance.textoSi = "Si";
      modalRef.componentInstance.textoNo = "No";
      modalRef.result.then(() => {
        this.modal.close();
      });
    } else {
      this.modal.close();
    }
  }

  armarListadoExcel(response: any) {
    const listadoErrores: { [key: string]: any }[] = [];
    for (const resp of response) {
      const respExportar: { [key: string]: any } = {};
      respExportar['*Operador'] = resp.aerovale.numeroDocumentoOperador;
      respExportar['*FechaHoraDespacho'] = resp.aerovale.fechaHoraDespacho;
      respExportar['*Cliente'] = resp.aerovale.numeroDocumentoCliente;
      respExportar['*Aeroespecialidades'] = resp.aerovale.codigoProducto;
      respExportar['*Cantidad'] = resp.aerovale.cantidad;
      respExportar['*Observacion'] = resp.error;
      listadoErrores.push(respExportar);
    }
    return listadoErrores;
  }

  exportarExcel() {
    this.excelService.exportAsExcelFile(this.armarListadoExcel(this.jsonResponse), 'AerovalesConErrores');
  }
}
